import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
app.initializers.add('external-links', () => {
  extend('flarum/forum/components/IndexSidebar', 'navItems', function (items) {
    // Vi lägger till en separator (ett streck) direkt under taggarna
    // Prioritet -49 gör att den hamnar precis ovanför din första länk (-50)
    items.add('custom-sidebar-separator', m("hr", {
      className: "Dropdown-separator"
    }), -49);
    items.add('custom-sidebar-heading', m("li", {
      className: "IndexSidebar-nav-heading"
    }, "F\xF6lj oss p\xE5"), -50);

    // Extern länk
    items.add('external-bluesky-link', m("a", {
      className: "Button Button--link",
      href: "https://bsky.app/profile/noden.forum",
      target: "_blank",
      rel: "noopener noreferrer"
    }, m("span", {
      className: "Button-icon"
    }, m("i", {
      className: "fa-brands fa-bluesky"
    })), m("span", {
      className: "Button-label"
    }, "Bluesky")), -55);
    // Extern länk
    items.add('external-mastodon-link', m("a", {
      className: "Button Button--link",
      href: "https://mastodon.social/@nodenforum",
      target: "_blank",
      rel: "noopener noreferrer"
    }, m("span", {
      className: "Button-icon"
    }, m("i", {
      className: "fa-brands fa-mastodon"
    })), m("span", {
      className: "Button-label"
    }, "Mastodon")), -57);
  });
});